import React, {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import ObjectSelected from "../../ObjectSelected/ObjectSelected";
import { popupcontext } from "../../../../context/Popupscontext";
import { useGetUsersDeviceQuery } from "../../../../Redux/service/Devices";
import { formatDateString } from "../../../../JsHelpers/DateFormat";
import { useMap } from "react-leaflet";
import { useSelector } from "react-redux";
import Loader from "../../../Helpers/Loader/Loader";
import { useLocation } from "react-router-dom";
import Delete from "../../../Helpers/Delete/DeletePopup";
import { useGetUsersGeofencesQuery } from "../../../../Redux/service/Geofences/Geofences";
import Display from "../../../Helpers/Table/Table Actions/Display";
import { draggablecontext } from "../../../../context/Draggablecontext";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans from "../../../../utils";
import { useGetDevicesByGroupQuery } from "../../../../Redux/service/Groups/GroupsBack";
import { Checkbox } from "antd";
import { useGetUserGroupQuery } from "../../../../Redux/service/Groups/Groups";
import L from "leaflet";
import { SpeedUnit } from "../../../../JsHelpers/PlatformUnits";
import usePermission from "../../../../hooks/usePermission";

const ITEM_HEIGHT = 64; // Your .object-table-row height
const BUFFER = 3;

export default function ObjectTableRows({
	userid,
	setImei,
	imei,
	name,
	setUserDevices,
	type,
}) {
	let {
		handleShowObject,
		handleShow,
		object,
		objectselect,
		setObjectselect,
		setHistoryPlayback,
		handleEditForm,
		refetchGeofences,
		setRefetchGeofences,
		reloadData,
		setReloadData,
		handleClose,
	} = useContext(popupcontext);
	useEffect(() => {
		if (!objectselect) {
			setImei(null);
		}
	}, [objectselect]);
	let { pathname } = useLocation();
	const [permission, setpermission] = useState(null);
	useEffect(() => {
		if (pathname === "/geofences") {
			setpermission("GEOFENCES");
		} else {
			setpermission("LIVETRACKINGHISTORY");
		}
	}, [pathname]);
	const { view, edit, delete: remove } = usePermission(permission);
	const inf = useSelector((state) => state.users.user);
	const { data: Groups = [] } = useGetUserGroupQuery(inf?.id, {
		skip: !inf?.id || pathname !== "/livetracking",
	});
	let { searchQuery, filter, setSearchQuery, trackingType } =
		useContext(filtrationcontext);
	let { handleFocusClick } = useContext(draggablecontext);
	const [selectedId, setSelectedId] = useState();
	const [shownData, setShownData] = useState([]);
	const [parentname, setParentName] = useState("");
	const {
		ObjectsearchQuery,
		setTrackingTypeIds,
		trackingTypeIds,
		parentCheck,
		childCheck,
	} = useContext(filtrationcontext);
	let {
		data,
		isLoading,
		refetch: RefetchDevices,
	} = useGetUsersDeviceQuery(
		{ userId: userid, type },
		{
			skip: pathname !== "/livetracking" || !userid || !type,
		}
	);
	let { data: GroupDevices, refetch: RefetchGroups } =
		useGetDevicesByGroupQuery(userid, {
			skip: !filter || userid === undefined || pathname !== "/livetracking",
		});
	const { data: Geofences, refetch } = useGetUsersGeofencesQuery(userid, {
		skip: !userid || pathname !== "/geofences",
	});
	const positions = useSelector((state) => state.webSocket.positions);
	const devices = useSelector((state) => state.webSocket.devices);
	const map = useMap();
	const lang = localStorage.getItem("lang") || "en";
	const scrollRef = useRef(null);
	const [startIndex, setStartIndex] = useState(0);
	const [loadedIndexes, setLoadedIndexes] = useState(new Set());
	const [containerHeight, setContainerHeight] = useState(0);
	const [visibleCount, setVisibleCount] = useState(0);
	const handleScroll = () => {
		const scrollTop = scrollRef.current.scrollTop;
		const newStart = Math.floor(scrollTop / ITEM_HEIGHT);
		if (newStart !== startIndex) {
			setStartIndex(newStart);
		}
	};
	const visibleStart = Math.max(0, startIndex - BUFFER);
	const visibleEnd = startIndex + visibleCount + BUFFER;
	// console.log("trackingTypeIds", trackingTypeIds);
	useEffect(() => {
		const updateVisibleCount = () => {
			const width = window.innerWidth;

			if (width >= 4000) {
				setVisibleCount(35);
			} else if (width >= 1400) {
				setVisibleCount(15);
			} else if (width >= 992) {
				setVisibleCount(10);
			} else if (width >= 768) {
				setVisibleCount(7);
			} else {
				setVisibleCount(5); // fallback
			}
		};

		// Set on initial load
		updateVisibleCount();

		// Update on resize
		window.addEventListener("resize", updateVisibleCount);
		return () => window.removeEventListener("resize", updateVisibleCount);
	}, []);
	// Simulate loading
	useEffect(() => {
		const toLoad = [];
		for (let i = visibleStart; i < visibleEnd && i < shownData?.length; i++) {
			if (!loadedIndexes.has(i)) {
				toLoad.push(i);
			}
		}

		if (toLoad?.length > 0) {
			const timeout = setTimeout(() => {
				setLoadedIndexes((prev) => new Set([...prev, ...toLoad]));
			}, 300); // Simulated delay
			return () => clearTimeout(timeout);
		}
	}, [startIndex, shownData, loadedIndexes]);

	useEffect(() => {
		if (
			shownData?.filter((item) =>
				item.disabled === false && filter
					? item.groupId !== 0
					: item.groupId === 0 || unGroupedVehicles(item.groupId)
			).length < visibleCount
		) {
			setContainerHeight(ITEM_HEIGHT * shownData?.length);
		} else {
			setContainerHeight(ITEM_HEIGHT * visibleCount);
		}
	}, [shownData?.length]);
	useEffect(() => {
		if (type) {
			setTrackingTypeIds([]);
		}
	}, [type]); // only triggers on type change ✅

	// ✅ 2️⃣ Update based on shownData or parentCheck
	useEffect(() => {
		const filteredIds =
			(parentCheck?.length === 0
				? shownData
						?.filter((item) => item.groupId === 0)
						?.map((item) => item.id)
				: shownData
						?.filter((item) => parentCheck.includes(item.groupId))
						?.map((item) => item.id)) || [];

		setTrackingTypeIds((prev) => {
			// ✅ If parentCheck > 0 → append to previous
			if (parentCheck?.length > 0) {
				const combined = [...(prev || []), ...filteredIds];
				return Array.from(new Set(combined)); // ✅ unique list
			}

			// ✅ If parentCheck empty → start fresh
			return filteredIds;
		});
	}, [shownData, parentCheck]);

	useEffect(() => {
		return () => setSearchQuery("");
	}, [setSearchQuery]);

	useEffect(() => {
		const newData = !filter
			? data
			: GroupDevices?.filter((item) => {
					const deviceType = item?.attributes?.device_type;

					if (type === "mobility") {
						return deviceType === "mobile";
					}

					if (type === "vehicle") {
						return !deviceType;
					}

					return true;
			  });
		let filteredData = newData?.filter((devices) => {
			const matchesSearch = ObjectsearchQuery
				? devices.name.toLowerCase().includes(ObjectsearchQuery.toLowerCase())
				: true;
			return matchesSearch;
		});
		setShownData(filteredData);
	}, [ObjectsearchQuery, filter, data, GroupDevices, type]);
	useEffect(() => {
		if (objectselect === false) {
			setSelectedId(null);
			//setImei(null);
			setHistoryPlayback({ state: false, Id: null });
		}
	}, [objectselect]);
	const handleRowClick = useCallback(
		async (id, lat, lon, imei, groupname) => {
			if (id === selectedId) {
				setSelectedId(null);
				setObjectselect(false);
				setImei(null);
				setHistoryPlayback({ state: false, Id: null });
			} else {
				await handleClose("objectSelected");
				await setObjectselect(false);
				setParentName(groupname);
				setSelectedId(id);
				setObjectselect(true);
				setImei(imei);
				setHistoryPlayback({ state: true, Id: id });

				const targetCoordinates = lat && lon ? [lat, lon] : [33, 30];
				map.setView(targetCoordinates, 13);
				map.scrollWheelZoom.disable();
				handleShowObject();
			}
		},
		[
			selectedId,
			setObjectselect,
			setHistoryPlayback,
			handleClose,
			map,
			handleShowObject,
		]
	);
	const handleGeoRowClick = (coord, id) => {
		setObjectselect(id === selectedId ? !objectselect : true);
		setSelectedId(id);
		if (Array.isArray(coord) && coord.length > 0) {
			const bounds = L.latLngBounds(coord);
			const center = bounds.getCenter();
			map.setView(center, 16); // or use map.flyTo(center, 14)
		}
	};
	const handleDeleteClick = (GeoId) => {
		if (GeoId) {
			handleShow("deleteItem", "geofences", GeoId);
		}
	};
	const parseWKTPolygon = (wkt) => {
		const cleanedWKT = wkt.replace("POLYGON ((", "").replace("))", "");
		const coordinates = cleanedWKT.split(", ").map((coord) => {
			const [lng, lat] = coord.split(" ").map(Number);
			return [lng, lat];
		});
		return coordinates;
	};
	useEffect(() => {
		if (refetchGeofences && pathname === "/geofences") {
			refetch();
			setRefetchGeofences(false);
		}
	}, [refetchGeofences, refetch, setRefetchGeofences, pathname]);
	useEffect(() => {}, []);
	const filteredGeofences = Geofences?.filter((geofence) =>
		geofence.name.toLowerCase().includes(searchQuery.toLowerCase())
	);
	useEffect(() => {
		if (reloadData) {
			RefetchDevices();
			RefetchGroups();
			setReloadData(false);
		}
	}, [reloadData]);
	const deviceMap = useMemo(() => {
		const map = new Map();
		devices?.forEach((d) => map.set(d.id, d));
		return map;
	}, [devices]);

	const positionMap = useMemo(() => {
		const map = new Map();
		positions?.forEach((p) => map.set(p.deviceId, p));
		return map;
	}, [positions]);

	if (isLoading)
		return (
			<div
				style={{
					height: `${containerHeight}px`,
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Loader />
			</div>
		);

	if (
		(pathname === "/geofences" && filteredGeofences?.length === 0) ||
		(pathname === "/livetracking" && shownData?.length === 0)
	) {
		return (
			<>
				<div className="my-2 p-2">
					<div className="text-center text-success fs-16 fw-700">
						{trans("No data shown")}
					</div>
				</div>
			</>
		);
	}

	function getUnit(unit) {
		if (unit === "kmh") {
			return "km/h";
		} else if (unit === "mph") {
			return "mph";
		} else if (unit === "kn") {
			return "kn";
		} else {
			return "kn"; // Default unit
		}
	}
	const unGroupedVehicles = (groupId) => {
		if (!Groups || Groups.length === 0) {
			return true;
		} else {
			return !Groups.some((g) => g.id === groupId);
		}
	};
	const totalHeight =
		shownData?.filter((item) =>
			item.disabled === false && filter
				? item.groupId !== 0
				: item.groupId === 0 || unGroupedVehicles(item.groupId)
		)?.length * ITEM_HEIGHT;
	const renderHeight = Math.min(containerHeight, totalHeight);
	console.log("shownData", shownData);
	console.log("selected", selectedId);
	return (
		<>
			{pathname === "/livetracking" && (
				<div
					ref={scrollRef}
					onScroll={handleScroll}
					style={{
						height: `${renderHeight}px`, // Adjusted height dynamically
						overflowY: "auto",
						position: "relative",
					}}
				>
					<div
						style={{
							height: `${
								shownData?.filter((item) =>
									item.disabled === false && filter
										? item.groupId !== 0
										: item.groupId === 0 || unGroupedVehicles(item.groupId)
								)?.length * ITEM_HEIGHT
							}px`,
							position: "relative",
						}}
					>
						{shownData
							?.filter((item) =>
								item.disabled === false && filter
									? item.groupId !== 0
									: item.groupId === 0 || unGroupedVehicles(item.groupId)
							)

							?.slice(visibleStart, visibleEnd)
							?.map((i, relIndex) => {
								const index = visibleStart + relIndex;

								if (!loadedIndexes.has(index)) {
									return (
										<div
											key={index}
											style={{
												position: "absolute",
												top: `${index * ITEM_HEIGHT}px`,
												height: `${ITEM_HEIGHT}px`,
												width: "100%",
												display: "flex",
												alignItems: "center",
												padding: "0 16px",
												background: "#f0f0f0",
												color: "#888",
											}}
										>
											Loading...
										</div>
									);
								}
								const device = deviceMap.get(i.id);
								const position = positionMap.get(i.id);
								const speed = position ? `${Math.round(position.speed)}` : 0;
								return (
									<div
										key={i.id}
										className="object-table object-table-row"
										onClick={() =>
											handleRowClick(
												i.id,
												position?.latitude ?? 24.7136,
												position?.longitude ?? 46.6753,
												i?.uniqueId,
												i?.groupId
											)
										}
										style={{
											position: "absolute",
											top: `${index * ITEM_HEIGHT}px`,
											width: "100%",
											backgroundColor: i.uniqueId === imei && "#eaf4ec",
										}}
									>
										{/* <div className={`${lang === "en" ? "mr-16" : "ml-16"}`}>
											<Checkbox
												checked={i.uniqueId === imei}
												onChange={() => {}}
											/>
										</div> */}
										<div className="fs-14 fw-400 object-table-element w-84">
											{i?.name}
										</div>
										{type === "vehicle" ? (
											<>
												{" "}
												<div className="fs-14 fw-400 object-table-element">
													<div className="d-flex">
														<div className={lang === "en" ? "me-1" : "ms-1"}>
															{device?.status === "online" &&
															position?.attributes.motion !== false
																? SpeedUnit(speed, inf.attributes?.speedUnit)
																: `0 ${trans(
																		getUnit(inf?.attributes?.speedUnit)
																  )}`}
														</div>
													</div>
												</div>
											</>
										) : (
											<>
												<div className="fs-14 fw-400 object-table-element">
													{i?.attributes?.current_user_name
														? i?.attributes?.current_user_name
														: "N/A"}
												</div>
											</>
										)}
										<div
											className="fs-14 fw-400 object-table-element"
											style={{ width: "80px" }}
										>
											<p className="m-0">
												{device?.lastUpdate
													? formatDateString(device?.lastUpdate)
													: i?.lastUpdate
													? formatDateString(i?.lastUpdate)
													: "N/A"}
											</p>
										</div>
										<div className="object-table-element">
											<div
												className={
													device?.status === "online"
														? "status-online"
														: "status-offline"
												}
											></div>
										</div>
										<div
											className="object-table-element object-eye-focus"
											onClick={(e) => {
												e.stopPropagation();
												handleFocusClick(i.id, i?.uniqueId, i);
											}}
										>
											<img
												src={`${process.env.PUBLIC_URL}/assets/Eye.svg`}
												alt="Eye Icon"
												title={trans("Multi-view")}
											/>
										</div>
									</div>
								);
							})}
					</div>
				</div>
			)}
			{objectselect && imei && (
				<ObjectSelected
					imei={imei}
					setimei={setImei}
					device={shownData?.find((item) => item.id === selectedId)}
					position={positions?.find((pos) => pos.deviceId === selectedId)}
					type={type}
				/>
			)}

			{pathname === "/geofences" && (
				<>
					{filteredGeofences?.length > 0 &&
						filteredGeofences
							.filter((j) => j.area?.trim().toUpperCase().startsWith("POLYGON"))
							.map((i) => {
								const coordinates = parseWKTPolygon(i.area);
								return (
									<div key={i?.id}>
										<div
											className="object-table object-table-row"
											onClick={() => handleGeoRowClick(coordinates, i.id)}
										>
											<div className={`${lang === "en" ? "mr-16" : "ml-16"}`}>
												<Checkbox
													checked={i.id === selectedId}
													onChange={() => {}}
												/>
											</div>
											<div className="fs-14 fw-400 object-table-element w-50">
												{i?.name}
											</div>
											<div className="object-table-element d-flex">
												{view && (
													<Display GeoId={i.id} type="geofences" show={true} />
												)}
												{edit && (
													<img
														role="button"
														src={`${process.env.PUBLIC_URL}/assets/Edit.svg`}
														alt="edit"
														onClick={() => {
															handleEditForm("geofences", i.id);
														}}
													/>
												)}
												{remove && (
													<Delete
														GeoId={i?.id}
														handleDeleteClick={() => {
															handleDeleteClick(i.id);
														}}
														show={true}
													/>
												)}
											</div>
										</div>
									</div>
								);
							})}
				</>
			)}
		</>
	);
}
